import React, { useState, useMemo, useEffect } from 'react'
import { Loading, PageTitle, Input, Button } from 'src/components'
import { more } from 'src/assets/png'
import { useStyles } from './styles'

import { useGetPastureList } from 'src/hooks/api/pasture/useGetPastureList'
import { Card } from './components/Card'
import { Grid } from '@material-ui/core'
import { PastureDto } from 'src/dto/pasture.dto'
import { Filter } from 'src/assets/svg'
import ROUTES from 'src/constants/routes'
import { useNavigate } from 'react-router-dom'
import { usePastureModal } from './hooks/usePastureModal'

export const Pastures: React.FC = () => {
  const navigate = useNavigate()

  const style = useStyles()
  const [searchValue, setSearchValue] = useState('')
  const [filterActive, setFilterActive] = useState(false)

  const { open: openPastureModal, PastureModal } = usePastureModal()

  const { data: pastureList, isLoading, isError, refetch } = useGetPastureList()
  const pastureListData = useMemo(() => {
    if (!pastureList) return []

    return pastureList.filter((item) => item.acao !== 'Removido')
  }, [pastureList])

  const isEmpty = !pastureListData?.length

  const filteredList = useMemo(() => {
    if (!pastureListData) return []

    return pastureListData.filter((item: PastureDto) =>
      item.descricao?.toLowerCase().includes(searchValue.toLowerCase())
    )
  }, [pastureListData, searchValue])

  useEffect(() => {
    if (!filterActive) {
      setSearchValue('')
    }
  }, [filterActive])

  return (
    <>
      <div className={style.header}>
        <div className={style.headerContent}>
          <PageTitle title='Locais' />
          <div className={style.headerBtnContainer}>
            <Button outlined disabled={isEmpty || isLoading} onClick={() => setFilterActive((prev) => !prev)}>
              <Filter className='icon' />
              FILTRAR
            </Button>

            <Button disabled={isLoading} onClick={openPastureModal}>
              <img src={more} alt='Incluir' />
              CADASTRAR
            </Button>
          </div>
        </div>
      </div>

      {isLoading || isError ? (
        <Loading isError={isError} refetch={refetch} />
      ) : (
        <div className={style.content}>
          {filterActive && (
            <Input
              type='text'
              placeholder='Procurar'
              value={searchValue}
              onChange={(value: string) => setSearchValue(value)}
            />
          )}

          {filteredList.length > 0 ? (
            <Grid container spacing={3}>
              {filteredList.map((item) => (
                <Grid item xs={12} sm={6} md={4} lg={3} xl={2} key={item.id}>
                  <div className='card__wrapper'>
                    <Card data={item} onClick={() => navigate(ROUTES.LOCATIONS.toDetails(item.id))} />
                  </div>
                </Grid>
              ))}
            </Grid>
          ) : (
            <div className={style.noDataContainer + ' ' + style.noDataCenter}>
              <span className={style.noDataText}>
                {filterActive ? 'Nenhum local encontrado para o filtro' : 'Nenhum local cadastrado'}
              </span>
            </div>
          )}
        </div>
      )}
      <PastureModal />
    </>
  )
}
